import React from 'react';
import './Chapters.scss';

function Chapter2() {
  return (
    <section className="chapter">
      <p className="chapter__paragraph">
        The lifeblood of the digital economy depends on a different kind of infrastructure—the kind
        that gathers, transmits, stores, and interprets terabytes of information in real time.
        Increasingly, that infrastructure exists in the cloud with powerful processors, fast
        networking, and scalable storage that can handle intensive enterprise, HPC, and machine
        learning workloads in hybrid cloud or edge environments.
      </p>
      <p className="chapter__paragraph">
        Here we will explore examples of companies across a broad spectrum of industries that have
        reinvented their infrastructures by using the power and flexibility of the AWS cloud with
        Intel technologies to improve the human experience and make our world healthier, more
        inclusive, and more convenient.
      </p>
    </section>
  );
}

export default Chapter2;
